import React, { useEffect, useRef, forwardRef } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";

export const BatchAllocationDialog = forwardRef(({
    visible,
    onHide,
    allocations,
    onAllocationChange,
    onConfirm,
    totalQty
}, ref) => {

    const confirmBtnRef = useRef(null);

    const footer = (
        <div className="flex justify-content-end gap-3">
            <Button
                label="Confirm"
                icon="pi pi-check"
                ref={confirmBtnRef}
                onClick={onConfirm}
            />
            <Button
                label="Cancel"
                icon="pi pi-times"
                onClick={onHide}
                className="p-button-secondary"
            />
        </div>
    );

    return (
        <Dialog
            header="Select Batch Allocation"
            visible={visible}
            onHide={onHide}
            onShow={() => confirmBtnRef.current?.focus()}
            footer={footer}
            style={{ width: '40vw' }}
        >
            <p>
                Total required: <b>{totalQty}</b>
            </p>

            <DataTable value={allocations} responsiveLayout="stack">
                <Column field="batch_number" header="Batch" />
                <Column field="expiry_date" header="Expiry" />
                <Column field="available_quantity" header="Available" />
                <Column
                    field="allocated_quantity"
                    header="Allocate"
                    body={(rowData, { rowIndex }) => (
                        <InputNumber
                            value={rowData.allocated_quantity}
                            min={0}
                            max={rowData.available_quantity}
                            onValueChange={e => onAllocationChange(rowIndex, e.value)}
                        />
                    )}
                />
                <Column field="selling_price" header="Price" />
            </DataTable>
        </Dialog>
    );
});